<template>
  <div class="c-footer-banner" :style='{ backgroundImage: `url(${bannerImage})` }'>
    <div class="c-footer-banner-content">
      <div>
        <p class="c-footer-banner-text">WPS数字化教育解决方案</p>
        <p class="c-footer-banner-desc">开启WPS 365 教育版，畅享一体化教学办公管理体验</p>
      </div>
      <kd-button class="c-footer-banner-btn blue-text-btn" @click="handleBuy">购买套餐</kd-button>
    </div>
  </div>
</template>

<script>
import { common } from '@/common/constants/config';
import bannerWebp from '@/assets/images/home/footer-banner.webp';
import bannerPng from '@/assets/images/home/footer-banner.png';
import { getFromPage, getPageName } from '@/common/utils/index'
import infoCollect from '@/common/infoCollect';
import { openBuyPage } from '@/common/utils/business'

export default {
  name: 'c-footer-banner',
  data() {
    return {
      bannerImage: localStorage.isSupportWebp === 'true' ? bannerWebp : bannerPng,
    }
  },
  methods: {
    contactSales() {
      infoCollect.dwCollectData('button_click', 'banner_contact_sales', 'PC', 
        {'page_name': getPageName(), 'from_item': getFromPage()}
      )
      window.open(common.contactSales)
    },
    handleBuy() {
      openBuyPage('_self', { serviceVal: 'wps365_edu_application' })
    }
  }
}
</script>

<style lang="scss" scoped>
.c-hfb-banner {
  width: 100%;
  height: 125px;
  background-color: red;
  background: red;
}

.c-footer-banner {
  width: 100%;
  height: 152px;
  background-position: center;
  background-size: cover;
  position: relative;

  &-content {
    max-width: 1264px;
    min-width: 768px;
    margin: 0 auto;
    display: flex;
    padding: 34px 32px;
    position: relative;
  }

  &-text {
    font-weight: 700;
    font-size: 33px;
    line-height: 64px;
    color: #FFFFFF;
  }

  &-desc {
    font-size: 14px;
    line-height: 20px;
    color: rgba(255, 255, 255, 0.9);
  }

  &-btn {
    height: 58px;
    width: 184px;
    position: absolute;
    right: 32px;
    top: 50%;
    transform: translate(0, -50%);
  }
}
</style>
